import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

export const useUserIdParam = (): string => {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId) {
      navigate("/login");
    }
  }, [userId, navigate]);

  if (!userId) {
    throw new Error("userId is required but was not found in route params");
  }

  return userId;
};
